import React from 'react';
import { motion } from 'framer-motion';

export default function NotAnApp() {
  const points = [
    "This is not another app.",
    "Not a hotline.",
    "Not a monitoring tool.",
    "It's something the education system has never had.",
    "And has always needed."
  ];

  return (
    <section className="w-full py-24 md:py-40 flex justify-center text-center">
      <div className="max-w-3xl">
        <div className="flex flex-col gap-3 md:gap-4">
          {points.map((point, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.15 }}
              className={`text-xl md:text-3xl font-bold ${
                i >= 3 ? 'text-deep-blue' : 'text-navy/40'
              }`}
            >
              {point}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
}